/*
  Single configuration point for the "Share your challenge" call to action.

  While the intake destination is not yet available, keep this `null`. Every
  "Share your challenge" control across the site (hero, header nav, footer,
  final CTA band, mobile menu) then renders as an inert <button> that still
  LOOKS and BEHAVES like an active control (pointer cursor, hover + focus
  states) but performs no action on click.

  When IBM provides the destination URL, set it here (e.g. a full https URL).
  Every control then automatically becomes an <a target="_blank" rel="noopener">
  link opening in a new tab. No other code changes are required.
*/
export const SHARE_CHALLENGE_URL = "https://airtable.com/appuyaZGm6WjMF9bA/pagYb3GFE1eGsUMfa/form";
